import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Modal, ModalBody,
} from 'reactstrap';
import VideoThumbnail from 'react-video-thumbnail';
import {
  ERROR_ICON, MEDIA_VIEW_TYPE, getTimeAgoFormat, BETA_POST_ENUM, RenderRequestPopup, RenderSocialIcons,
} from '../../utils';
import MediaPopup from './MediaPopup';

function BetaPostApproved(props) {
  const {
    isOpen, onClose, displayUser, shareType,
  } = props;
  const [modal, setModal] = useState(isOpen);
  const [mediaPopup, setMediaPopup] = useState(false);
  const [mediaItem, setMediaItem] = useState();
  const isOfferPublished = (displayUser.status === BETA_POST_ENUM.PUBLISHED || displayUser.status === BETA_POST_ENUM.COMPLETED);

  const toggle = () => {
    setModal(!modal);
    onClose();
  };

  /* function to close the publish post modal */
  const toggleMediaModal = () => {
    setMediaPopup(!mediaPopup);
  };

  /* function to filter out the data based on the current status of the request and
    find the time ago calling getTimeAgoFormat function */
  const displayTimeAgo = (status, timeLine) => {
    const filteredData = timeLine.length && timeLine.filter((timeline) => timeline.status === status);
    return getTimeAgoFormat(filteredData[0].createdAt);
  };

  /* function called on click of media post to open image or video in modal
    timeline segment object passed as a variable */
  const openMediaPopup = (item) => {
    setMediaPopup(true);
    setMediaItem(item);
  };

  const renderMedia = (mediaObj, mediaFile) => {
    switch (mediaFile.mediaType) {
      case MEDIA_VIEW_TYPE.IMAGE:
        return mediaObj;
      case MEDIA_VIEW_TYPE.VIDEO:
        return (
          <>
            <VideoThumbnail
              videoUrl={mediaFile.url}
            />
          </>
        );
      default:
        break;
    }
    return null;
  };

  return (
    <Modal isOpen={modal} toggle={toggle} className="modal-request modal-beta-request approved-reject  modal-dialog-centered">
      <ModalBody>
        <div className={`${isOfferPublished ? 'modal-published-account' : 'modal-request-account'}
          ${displayUser && displayUser.status === BETA_POST_ENUM.REJECTED ? 'rejected' : 'approved'}`}
        >
          {
            (!isOfferPublished)
            && (
              <h2>
                Draft Post Request
                <div className="social-icons">
                  {RenderSocialIcons(shareType).map((ele) => ele)}
                </div>
                {(displayUser && displayUser.status) === BETA_POST_ENUM.BETA_POST_APPROVED
                  ? 'Approved'
                  : (
                    <div className="error-text text-with-indent">
                      <img
                        src={ERROR_ICON}
                        alt="offer"
                      />
                      <p>
                        {` ${displayUser.rejectReason.preDefined} ${displayUser.rejectReason.custom}`}
                      </p>
                    </div>
                  )}
              </h2>
            )
          }
          <RenderRequestPopup
            displayUser={displayUser}
            displayTimeAgo={displayTimeAgo}
            mediaPopup={openMediaPopup}
            renderMedia={renderMedia}
            shareType={shareType}
            sharedPost={displayUser.sharedPost}
          />
        </div>
        {mediaPopup && (
          <MediaPopup
            isOpen={mediaPopup}
            onClose={() => { toggleMediaModal(); }}
            timelineData={mediaItem}
          />
        )}
      </ModalBody>
    </Modal>
  );
}

BetaPostApproved.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  displayUser: PropTypes.object.isRequired,
  shareType: PropTypes.object.isRequired,
  sharedPost: PropTypes.object.isRequired,
};

export default BetaPostApproved;
